import type { AnyObject } from "antd/es/_util/type";
import type { TableWrapperProps } from "../../../common/components/Table";
import { bladeActions } from "../../../features/blade/bladeSlice";
import type { TurbineData } from "./TurbineViewRender";
import { FileAddOutlined } from "@ant-design/icons";
import type { Blade } from "../../generated-axios-client";
import { EditableText, editableTypes } from "../../../common/components/EditableText";
import { dateValue } from "../../../common/columns";
import { ticketActions } from "../../../features/ticket/ticketSlice";
import { TableActions } from "../../../common/components/TableActions";
import { actions as routerActions } from "redux-router5";
import { routeNames } from "../../common/routes";

export const bladeTableRender: TableWrapperProps<TurbineData, AnyObject>["getRows"] = (
  intl,
  dispatch,
  turbineData,
  modalApi
) => {
  const { blades, turbine } = turbineData;

  const onChange = (id: string) => (name: string, value: string) => {
    dispatch(bladeActions.bladeEdit({ id: id, data: { [name]: value } }));
  };

  const prefilTicket = (client?: string, turbine?: string, blade?: string) => {
    dispatch(
      ticketActions.setInitialValue({
        client: client,
        turbine: turbine,
        items: [{ blade: blade }],
      })
    );
    dispatch(
      routerActions.navigateTo(routeNames.TICKET_CREATE, {
        client: client,
        turbine: turbine,
      })
    );
  };

  return Object.values(blades.results).map((blade: Blade) => {
    return {
      key: blade.id,
      manufacturer: (
        <EditableText
          variableName="manufacturer"
          variableValue={blade.manufacturer ? blade.manufacturer : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={blade.id ? onChange(blade.id) : undefined}
        />
      ),
      model: (
        <EditableText
          variableName="model"
          variableValue={blade.model ? blade.model : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={blade.id ? onChange(blade.id) : undefined}
        />
      ),
      serial_number: (
        <EditableText
          variableName="serial_number"
          variableValue={blade.serial_number ? blade.serial_number : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={blade.id ? onChange(blade.id) : undefined}
        />
      ),
      set_number: (
        <EditableText
          variableName="set_number"
          variableValue={blade.set_number ? blade.set_number : undefined}
          intl={intl}
          dataType={editableTypes.TEXT}
          onChange={blade.id ? onChange(blade.id) : undefined}
        />
      ),
      created_at: blade.created_at ? dateValue(blade.created_at, intl) : "—",
      updated_at: blade.updated_at ? dateValue(blade.updated_at, intl) : "—",
      actions: (
        <TableActions
          actions={[
            {
              key: "create-work-order",
              icon: <FileAddOutlined />,
              onClick: () => prefilTicket(turbine.client.id, turbine.id, blade.id),
              tooltip: "Create Work Order",
            },
          ]}
        />
      ),
    };
  });
};
